import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  Button,
  Col,
  Form,
  FormControl,
  FormLabel,
  InputGroup,
  Spinner,
} from 'react-bootstrap';
import useAuth from '../../hooks/useAuth';

import { emailPattern } from '../../common/constants';
import StatusAlert from '../../components/StatusAlert';

function InformalSingUpHook(props) {
  const navigate = useNavigate();
  const { addUser } = useAuth();
  const alertOpts = useRef({
    isShow: false,
    message: '',
  });
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const handleSignup = async (data) => {
    try {
      setIsLoading(true);
      const user = await addUser(data);
      // eslint-disable-next-line no-console
      console.log(`signup successful, user: ${user}`);
      setIsLoading(false);
      navigate('/login');
    } catch (err) {
      // Need to useRef to avoid cyclic reference of the show state in StatusAlert but we now must set alertOps
      // before a set state call so that StatusAlert can render.
      // TODO: Figure a more elegant solution for auto-dismissal alert.
      this.alertOpts.current = {
        isShow: true,
        message: err.message,
      };
      setIsLoading(false);
    }
  };
  const handleDismiss = () => {
    alertOpts.current.isShow = false;
  };

  return (
    <>
      <div>
        <strong>STEP 2</strong>
        <p>
          Please fill your correct email address and mobile number.
        </p>
        <Form className="row g-2" noValidate>
          <Form.Group as={Col} lg="6" controlId="inputEmail">
            <FormLabel>Email</FormLabel>
            <FormControl type="email"
                         isInvalid={errors.email}
                         placeholder="Email@domain.com"
                         {
                           ...register('email', {
                             required: true,
                             pattern: emailPattern,
                           })
                         }
            />
            <Form.Control.Feedback type="invalid">
              {errors.email?.type === 'required' && 'Email is required'}
              {errors.email?.type === 'pattern' && 'Invalid email'}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="inputPhoneNumber">
            <Form.Label>Phone Number</Form.Label>
            <InputGroup hasValidation>
              <InputGroup.Text id="inputGroupPrepend">+255</InputGroup.Text>
              <Form.Control type="number"
                            isInvalid={ errors.phonenumber }
                            placeholder="756140140"
                            aria-describedby="inputGroupPrepend"
                            { ...register('phonenumber', { required: true }) }
              />
              <Form.Control.Feedback type="invalid">
                { errors.phonenumber && 'Phone Number is required' }
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Button className="w-100 btn btn-green"
                  type="button"
                  disabled={isLoading}
                  onClick={ handleSubmit(handleSignup) }
          >
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"
                     hidden={ !isLoading }/>
            <span className="px-2">Sign up</span>
          </Button>
        </Form>
      </div>
      <StatusAlert show={alertOpts.current.isShow}
                   variant="failure"
                   message={alertOpts.current.message}
                   onDismiss={handleDismiss}
      />
    </>
  );
}

export default InformalSingUpHook;
